import React from 'react';

import { t } from '../../services/i18nService';
import fileDeliveryService from '../../services/FileDeliveryService';
import sessionReader from '../../store/readHelpers/SessionReader';
import OptionsTopBar from './OptionsTopBar';
import Confirmation from './Confirmation';
import navigationService from '../../services/NavigationService';
import apiTools from '../../services/api/ApiTools';
import settingsReader from '../../store/readHelpers/SettingsReader';
import { getA11yAttributesV2 } from '../../services/a11yIIBScreenReaderService';

import styles from './options.scss';

class OptionsFileDelivery extends React.Component {
    state = {
        deliverBlank: false,
        fileContents: fileDeliveryService.getEncryptedFileContent(false),
    };

    actionHandler = () => {
        fileDeliveryService.saveDelivery(this.state.fileContents);
        if (sessionReader.isOfflineMode()) {
            // using localStorage for  offline dashboard awareness of delivered component
            const componentKey = apiTools.getOfflineDeliveryLocalStorageKey();
            localStorage.setItem(componentKey, 'delivered');
            navigationService.navigateToFileDelivered();
        }
    };

    toggleDeliverBlank = () => {
        this.setState({
            deliverBlank: !this.state.deliverBlank,
            fileContents: fileDeliveryService.getEncryptedFileContent(!this.state.deliverBlank),
        });
    };

    render() {
        const mainButtonText = t('options.fileDeliveryButtonText');
        const requireInvigilatorPassword = sessionReader.testUsesInvigilatorPassword();
        const requireBlobForLink = fileDeliveryService.browserRequireBlobForLink();
        const isDeliverBlankEnabled = settingsReader.isDeliverBlankEnabled();

        let fileBlobForLink;
        if (requireBlobForLink) {
            fileBlobForLink = fileDeliveryService.getFileBlobForLink(this.state.fileContents);
        }
        const contentChildren = (
            <p className={styles.toggleDeliverBlank}>
                <input
                    id="toggleDeliverBlank"
                    type="checkbox"
                    checked={this.state.deliverBlank}
                    onChange={this.toggleDeliverBlank}
                    {...getA11yAttributesV2({ 'aria-label': t('options.fileDeliveryDeliverBlank') })}
                />
                <label htmlFor="toggleDeliverBlank">
                    {t('options.fileDeliveryDeliverBlank')}
                </label>
            </p>
        );

        return (
            <div>
                <OptionsTopBar
                    title={t('options.fileDelivery')}
                    showOptionsButton
                    exitButtonProps={getA11yAttributesV2({ 'aria-label': t('options.closeOptionsMenu') })}
                    optionsButtonProps={getA11yAttributesV2({ 'aria-label': t('options.backToOptionsList') })}
                />
                <div className={styles.mainContentArea} role="main">
                    <Confirmation
                        contentChildren={isDeliverBlankEnabled ? contentChildren : null}
                        text={t('options.fileDeliveryExplain')}
                        mainButtonText={mainButtonText}
                        actionHandler={this.actionHandler}
                        requireInvigilatorPassword={requireInvigilatorPassword}
                        fileBlobForLink={fileBlobForLink}
                        fileBlobName={fileDeliveryService.getFileName()}
                        {...getA11yAttributesV2({
                            confirmButtonA11y: { 'aria-label': t('general.continue') },
                            cancelButtonA11y: { 'aria-label': t('generic.cancel') },
                        })}
                    />
                </div>
            </div>
        );
    }
}

export default OptionsFileDelivery;
